import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=1fdaaee1&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=ts"
export * from "./Form2.vue?vue&type=script&lang=ts"
import style0 from "./Form2.vue?vue&type=style&index=0&id=1fdaaee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdaaee1",
  null
  
)

export default component.exports